import React, {FC} from 'react'
import {Form, FormControlProps, Stack} from 'react-bootstrap'
import {FaSearch} from 'react-icons/fa'
import styled from 'styled-components'

const StyledControl = styled(Form.Control)`
  border: 0;
  padding: 0;
  min-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  transition: 300ms width ease-in-out;
`

interface TextInputProps extends FormControlProps {
  label?: any
  icon?: React.ReactNode
}

export const TextInputV2: FC<TextInputProps> = (props) => {
  const formControlRef = React.useRef<HTMLInputElement>(null)

  React.useEffect(() => {
    const input = formControlRef.current
    if (input) {
      input.addEventListener('focus', () => {
        input.style.width = '140px'
      })
      input.addEventListener('blur', () => {
        input.style.width = '100%'
      })
    }
  }, [])

  return (
    <>
      {props.label && <Form.Label>{props.label}</Form.Label>}
      <Stack
        direction='horizontal'
        gap={2}
        style={{
          border: '1.8px solid #d9dce4',
          background: 'white',
          borderRadius: 6,
          padding: '6.5px 10px',
        }}
      >
        <div style={{width: 'auto'}}>{props.icon}</div>
        <StyledControl
          ref={formControlRef}
          aria-label='Default select example'
          size='sm'
          {...props}
        />
      </Stack>
    </>
  )
}

TextInputV2.defaultProps = {
  icon: <FaSearch size={12} color='gray' style={{padding: 0}} />,
}
